import { WSGrid, WSList } from "@wingspanhq/fe-component-library";
import { WingspanAccounts } from "../../Settings/components/WingspanAccounts";
import { InternalAccountBalance } from "../components/InternalAccountBalance";
import { queriesInternalAccounts } from "@query";

type Props = {
  internalAccountId: string;
};

export const RouteNewDashboard: React.FC<Props> = props => {
  const queryIntenalAccount =
    queriesInternalAccounts.getInternalAccount.useQuery({
      internalAccountId: props.internalAccountId
    });

  return (
    <WSGrid gutter={{ s: "3XL" }}>
      <WSGrid.Item span={{ m: "8" }}>
        <InternalAccountBalance internalAccountId={props.internalAccountId} />
      </WSGrid.Item>

      <WSGrid.Item span={{ m: "4" }}>
        <WSList gap="2XL">
          <WingspanAccounts accountType={queryIntenalAccount.data?.type} />
        </WSList>
      </WSGrid.Item>
    </WSGrid>
  );
};
